// extracted by mini-css-extract-plugin
export default {"page":"PlanOfficePage_page__sjziX","title":"PlanOfficePage_title__RRfib","input":"PlanOfficePage_input__pzACp","button":"PlanOfficePage_button__8ucPN"};